import { configureStore } from '@reduxjs/toolkit'

import authSlice from 'store/auth'
import sponsorSlice from 'store/sponsor'
import speakerSlice from 'store/speaker'
import venueSlice from 'store/venue'
import eventSlice from 'store/event'
import attendeeSlice from 'store/attendee'
import sessionSlice from 'store/session'
import talkSlice from 'store/talk'
import configSlice from 'store/config'
import conferenceSlice from 'store/conference'
import announcementSlice from 'store/announcements'
import iconSlice from 'store/icon'
import vendorSlice from 'store/vendor'
import moderatorSlice from 'store/moderator'
import sponsorshipLevelSlice from 'store/sponsorship-level'
import adminsSlice from 'store/Admins'
import subjectSlice from 'store/subject'
import pollingSlice from 'store/polling'
import settingSlice from 'store/settings'
import attendanceSlice from 'store/attendance'
import badgesSlice from 'store/badges'

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    sponsor: sponsorSlice.reducer,
    speaker: speakerSlice.reducer,
    venue: venueSlice.reducer,
    event: eventSlice.reducer,
    attendee: attendeeSlice.reducer,
    session: sessionSlice.reducer,
    talk: talkSlice.reducer,
    config: configSlice.reducer,
    conference: conferenceSlice.reducer,
    announcements: announcementSlice.reducer,
    icon: iconSlice.reducer,
    vendor: vendorSlice.reducer,
    moderator: moderatorSlice.reducer,
    sponsorshipLevel: sponsorshipLevelSlice.reducer,
    admins: adminsSlice.reducer,
    subjects: subjectSlice.reducer,
    polling: pollingSlice.reducer,
    setting: settingSlice.reducer,
    attendance: attendanceSlice.reducer,
    badges: badgesSlice.reducer
  },
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({
      serializableCheck: false
    })
  ]
})

export default store
